<template>
<b-modal v-model="showFlg"
         size="lg"
         header-bg-variant="light"
         :modal-class="'setHeight081'"
         :title="$t('sh063.labels.changeHopeDateAndTime')"
         :hide-footer="true"
         @hide ="handleCancel"
         no-close-on-backdrop>
    <div class="sh063" v-cloak>
        <div class="pageFeed">
            <div class="section-inner">
                <h3 class="subTitle">{{$t('sh063.labels.deliDates')}}</h3><br>
                <div>
                    <!--page table -->
                    <table class="table" id="cart-history">
                        <tbody>
                            <tr class="tableTr">
                                <!-- 希望日 -->
                                <th :class="sh063TdkReqModel.tdkYmdHissuFlg == 1?'text-danger':''">{{$t("sh063.labels.hopeDates")}}</th>
                                <td bgcolor="#FFFFFF" height="120" class="td-res-height">
                                    <div class="div_unspecified" style="display:flex;align-items:center;">
                                        <!-- 指定なし -->
                                        <input class="sh063-inp-radioGroup1" id="radioGroup1" type="radio" name="radioGroup1" :value="1" 
                                            :disabled="sh063ItemControl.radioGrp1Flg != 1" v-model="sh063TdkReqModel.radioGroup1" @click="hopeDayRadio(1)"/>
                                        <label class="sh063-lbl-radioGroup1" for="radioGroup1">：{{$t("sh063.labels.unspecified")}}</label><br><br>
                                    </div>
                                    <div class="div_hopeDay" style="display:flex;align-items:center;">
                                        <!--お届希望日-->
                                        <input class="sh063-inp-radioGroup2" id="radioGroup2" type="radio" name="radioGroup1" :value="2" 
                                            :disabled="sh063ItemControl.radioGrp2Flg != 1" v-model="sh063TdkReqModel.radioGroup1" @click="hopeDayRadio(2)"/>
                                        <label class="sh063-lbl-radioGroup2" for="radioGroup2">：{{$t("sh063.labels.deliDateSetting")}}</label>
                                        <select name="hopeDay" id="hopeDay" class="hopeDay" :disabled="sh063ItemControl.ymdHopeFlg != 1 || sh063TdkReqModel.radioGroup1 != 2" 
                                            v-model="sh063TdkReqModel.hopeTdkYmd" style="width:240px;">
                                                <option v-for="day in sh063Init.tdkYmdList" :value="day.KEY" :key="day.KEY" >{{day.VALUE}}</option>
                                        </select><br><br>
                                    </div>
                                    <!--のみ、以降オプション-->
                                    <div v-if="sh063Init.chakubiOption == 1" class="div_afterDay" style="display:flex;align-items:center;">
                                        <!--以降にお届け-->
                                        <input class="sh063-inp-radioGroup2" id="radioGroup3" type="radio" name="radioGroup1" :value="3" 
                                            :disabled="sh063ItemControl.radioGrp3Flg != 1" v-model="sh063TdkReqModel.radioGroup1" @click="hopeDayRadio(3)"/>
                                        <label class="sh063-lbl-radioGroup3">：</label>
                                        <select name="afterDay" id="afterDay" class="hopeDay" :disabled="sh063ItemControl.ymdAftFlg != 1 || sh063TdkReqModel.radioGroup1 != 3" 
                                            v-model="sh063TdkReqModel.hopeTdkYmdAfter" style="width:240px;">
                                                <option v-for="day in sh063Init.tdkYmdList" :value="day.KEY" :key="day.KEY" >{{day.KEY}}</option>
                                        </select>
                                        <label class="sh063-lbl-radioGroup2" for="radioGroup3">{{$t("sh063.labels.deliAfterDate")}}</label>
                                    </div>
                                </td>
                            </tr>
                            <!-- ECサイトオプション50505（非表示）の場合は、お届け希望日時の枠自体を非表示にする -->
                            <tr class="tableTr" v-if="sh063Init.tdkTimeFlg == 1">
                                <!-- 希望時間 -->
                                <th :class="sh063TdkReqModel.tdkHstmHissuFlg == 1?'text-danger':''">{{$t("sh063.labels.deliTime")}}</th>
                                <td bgcolor="#FFFFFF" height="60" class="td-res-height">
                                    <!--お届希望時間帯-->
                                    <select name="hopeTime" id="hopeTime" class="hopeTime" :disabled="sh063ItemControl.timeHopeFlg != 1" 
                                        v-model="sh063TdkReqModel.hopeTdkTimeKbn" style="width:240px;">
                                        <option v-for="time in sh063Init.hopeTimeList" :value="time.KEY" :key="time.KEY" >{{time.VALUE}}</option>
                                    </select>  
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="btnSubmitsh063" style="display:flex;justify-content:center;align-items:center;gap:1rem;margin-top:1em;">
                    <!-- 閉じるボタン -->
                    <div style="width:33.3%;"><button class="sh063-btn-back" style="background-color:#a0a0a0;width:100%;padding:0.75em 1.5em;font-size:1em;cursor:pointer;" 
                        @click="showFlg = false" type="button">{{$t("common.buttons.close")}}</button></div>
                    <!-- 変更ボタン -->
                    <div style="width:33.3%;"><button class="sh063-btn-next" style="background-color:#d2323a;width:100%;padding:0.75em 1.5em;font-size:1em;cursor:pointer;" 
                        @click="doUpdate(sh063TdkReqModel.hopeTdkYmd,sh063TdkReqModel.hopeTdkYmdAfter,sh063TdkReqModel.hopeTdkTimeKbn)" type="button">{{$t("common.buttons.change")}}</button></div>
                </div>
            </div>
        </div>
    </div>
</b-modal>
</template>

<script>
import axios from "assets/js/request";
import common from 'assets/js/common';
import PageFeed from "../commonParts/PageFeedTdk";
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import EventBus from "assets/js/eventBus";

export default {
    name: "SH063TdkHopeDateGiftSetting",
    components: {
        PageFeed,
        InputNumber,
        EventBus,
        Breadcrumb
    },
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptOrderByType: {
            type: [Number,String]
        },
        data:{
            tdkNo:null,
            tdkSeq:null,
            hopeTdkYmd:null,
            hopeTdkTimeKbn:null,
            chakubiKbn:null,
            tdkYmdHissuFlg:null,
            tdkHstmHissuFlg:null
        }
    },
    data: function() {
        return {
            sh063TdkReqModel:{
                tdkNo:null,
                tdkSeq:null,
                hopeTdkYmd:null,
                hopeTdkTimeKbn:null,
                chakubiKbn:null,
                tdkYmdHissuFlg:null,
                tdkHstmHissuFlg:null
            },
            sh063ItemControl:{
                radioGrp1Flg:0,
                radioGrp2Flg:0,
                radioGrp3Flg:0,
                ymdHopeFlg:0,
                ymdAftFlg:0,
                timeHopeFlg:0
            },
            sh063Init:{
                chakubiOption:null,
                tdkYmdList:{},
                hopeTimeList:{}
            },
            queryData:null,
            SiteConstants: SiteConstants,
            showFlg: true,
            site: ""
        }
    },
    /*
    * Initialize
    */
    mounted: async function() {
        var _this = this;
        //画面初期化処理
        await _this.doInit();
        _this.doSetItem();
    },

    methods: {
        doInit: async function() {
            var _this = this;
            _this.sh063TdkReqModel.tdkNo = _this.data.tdkNo;
            _this.sh063TdkReqModel.tdkSeq = _this.data.tdkSeq;
            _this.sh063TdkReqModel.hopeTdkYmd = _this.data.tdkYmd;//お届け希望日
            _this.sh063TdkReqModel.hopeTdkTimeKbn = _this.data.tdkHmsKbn;//お届け時間帯区分
            _this.sh063TdkReqModel.chakubiKbn = _this.data.chakubiKbn;//着日区分 0：なし 1：のみ 2：以降 デフォルト＝０
            _this.sh063TdkReqModel.tdkYmdHissuFlg = _this.data.tdkYmdHissuFlg;//着日必須フラグ １：のみ ２：以降 デフォルト＝０ 
            _this.sh063TdkReqModel.tdkYmdErrFlg = _this.data.tdkYmdErrFlg;//着日指定不可フラグ デフォルト＝０
            _this.sh063TdkReqModel.tdkHstmHissuFlg = _this.data.tdkHstmHissuFlg;//配達時間帯必須フラグ デフォルト＝０
            _this.sh063TdkReqModel.tdkHstmErrFlg = _this.data.tdkHstmErrFlg;//配達時間帯指定不可フラグ デフォルト＝０

            _this.site = _this.$router.history.current.fullPath.split("/")[1];
            await axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH063 + _this.$UrlConstants.DO_INIT, _this.sh063TdkReqModel).then(function(response) {
                if(response.data.isLogin == false){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
                }else{
                    _this.sh063Init = response.data;
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });

        },
        
        /**
         * doSetItem
         */
        doSetItem() {
            var _this = this;
            //console.log('tdkSeq:'+_this.sh063TdkReqModel.tdkSeq);
            //console.log('tdkNo:'+_this.sh063TdkReqModel.tdkNo);
            //console.log('tdkYmd:'+_this.sh063TdkReqModel.hopeTdkYmd);
            //console.log('tdkHmsKbn:'+_this.sh063TdkReqModel.hopeTdkTimeKbn);
            //console.log('chakubiOption:'+_this.sh063Init.chakubiOption);
            //console.log('chakubiKbn:'+_this.sh063TdkReqModel.chakubiKbn);
            //console.log('tdkYmdHissuFlg:'+_this.sh063TdkReqModel.tdkYmdHissuFlg);
            //console.log('tdkYmdErrFlg:'+_this.sh063TdkReqModel.tdkYmdErrFlg);
            //console.log('tdkHstmHissuFlg:'+_this.sh063TdkReqModel.tdkHstmHissuFlg);
            //console.log('tdkHstmErrFlg:'+_this.sh063TdkReqModel.tdkHstmErrFlg);

            //制御マトリクスで制御処理を行う
            //着日区分 0：なし 1：のみ 2：以降 デフォルト＝０
            //着日必須フラグ １：のみ ２：以降 デフォルト＝０
            _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
            _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
            _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可能
            _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可能
            _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可能
            _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
            
            //1行目
            if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 0 
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可能
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可能
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                if(common.stringNvl(_this.sh063TdkReqModel.hopeTdkYmd)==''){
                    _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                } else {
                    _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                }
                //console.log('1行目');
            }
            //2行目
            if(_this.sh063Init.chakubiOption == 1
                    &&  (common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 1
                     || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == ''
                     || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 0)
                    && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
            //〇 のみ（顧客指定付き）
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                //console.log('2行目');
            } else if (_this.sh063Init.chakubiOption == 1
                    &&  (common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 2
                     || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == ''
                     || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 0)
                    && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
            //3行目
            //〇 以降（顧客指定無し）
                _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                _this.sh063TdkReqModel.radioGroup1 = 3          //以降 ラジオボタンを選択状態にする
                //console.log('3行目');
            }
            //4行目
            //〇 着日 指定不可フラグ＝１
            if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 0 
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 1 
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
                _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                //console.log('4行目');
            }
            //5行目
            //配達時間 必須フラグ＝１
            if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 0 
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 1
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可能
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可能
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                if(common.stringNvl(_this.sh063TdkReqModel.hopeTdkYmd)==''){
                    _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                } else {
                    _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                }
                //console.log('5行目');
            }
            //6行目
            if(_this.sh063Init.chakubiOption == 1
                    &&  (common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 1
                     || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == ''
                     || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 0)
                    && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                && _this.sh063TdkReqModel.tdkHstmHissuFlg == 1
                && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
            //〇 のみ（顧客指定付き） かつ 配達時間 必須フラグ＝１
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                //console.log('6行目');
            } else if (_this.sh063Init.chakubiOption == 1
                    &&  (common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 2
                     || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == ''
                     || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 0)
                && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                && _this.sh063TdkReqModel.tdkHstmHissuFlg == 1
                && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
            //7行目
            //〇 以降（顧客指定無し） かつ 配達時間 必須フラグ＝１
                _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                _this.sh063TdkReqModel.radioGroup1 = 3          //以降 ラジオボタンを選択状態にする
                //console.log('7行目');
            }
            //8行目
            if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 1
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 1
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
            //〇 着日 指定不可フラグ＝１ かつ 配達時間 必須フラグ＝１
                _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                //console.log('8行目');
            }
            //9行目
            //配達時間 指定不可フラグ＝１
            if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 0
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 1){
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可能
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可能
                _this.sh063ItemControl.timeHopeFlg = 0;         //希望時間 使用不可
                if(common.stringNvl(_this.sh063TdkReqModel.hopeTdkYmd)==''){
                    _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                } else {
                    _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                }
                //console.log('9行目');
            }
            //10行目
            if(_this.sh063Init.chakubiOption == 1
                    &&  (common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 1
                     || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == ''
                     || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 0)
                && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                && _this.sh063TdkReqModel.tdkHstmErrFlg == 1){
            //〇 のみ（顧客指定付き） かつ 配達時間 指定不可フラグ＝１
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 0;         //希望時間 使用不可
                _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                //console.log('10行目');
            } else if (_this.sh063Init.chakubiOption == 1
                    &&  (common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 2
                     || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == ''
                     || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 0)
                && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                && _this.sh063TdkReqModel.tdkHstmErrFlg == 1){
            //11行目
            //〇 以降（顧客指定無し） かつ 配達時間 指定不可フラグ＝１
                _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 0;         //希望時間 使用不可
                _this.sh063TdkReqModel.radioGroup1 = 3          //以降 ラジオボタンを選択状態にする
                //console.log('11行目');
            }
            //12行目
            if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 0 
                && _this.sh063TdkReqModel.tdkYmdErrFlg == 1 
                && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                && _this.sh063TdkReqModel.tdkHstmErrFlg == 1){
            //〇 着日 指定不可フラグ＝１ かつ 配達時間 指定不可フラグ＝１
                _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可
                _this.sh063ItemControl.timeHopeFlg = 0;         //希望時間 使用不可
                _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                //console.log('12行目');
            }
            //追加パターン
            //希望日		時間	
            //必須	不可	必須	不可
            //1	0	1	0
            //0	1	1	0→希望日指定不可
            //0	0	1	0
                        
            //1	0	0	1               →時間指定不可
            //0	1	0	1→希望日指定不可 →時間指定不可
            //0	0	0	1               →時間指定不可
                        
            //1	0	0	0
            //0	1	0	0→希望日指定不可
            //0	0	0	0
            if (_this.sh063Init.chakubiOption == 0){//着日区分
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可能
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能

                //希望日指定不可
                if(_this.sh063TdkReqModel.tdkYmdErrFlg == 1){
                    _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                    _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                    _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可能
                }
                //時間指定不可
                if(_this.sh063TdkReqModel.tdkHstmErrFlg == 1){
                    _this.sh063ItemControl.timeHopeFlg = 0;         //希望時間 使用不可
                }
                if(common.stringNvl(_this.sh063TdkReqModel.hopeTdkYmd)==''){
                    _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                } else {
                    _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                }
            }
            //console.log('radioGrp2Flg:'+_this.sh063ItemControl.radioGrp2Flg);
            //console.log('ymdHopeFlg:'+_this.sh063ItemControl.ymdHopeFlg);
            //console.log('radioGrp3Flg:'+_this.sh063ItemControl.radioGrp3Flg);
            //console.log('ymdAftFlg:'+_this.sh063ItemControl.ymdAftFlg);
            //console.log('radioGrp1Flg:'+_this.sh063ItemControl.radioGrp1Flg);
            //console.log('timeHopeFlg:'+_this.sh063ItemControl.timeHopeFlg);
        },
        /**
         * doUpdate
         * @param {String} hopeTdkYmd
         * @param {String} hopeTdkYmdAfter
         * @param {String} hopeTdkTimeKbn
         */
        doUpdate: async function(hopeTdkYmd,hopeTdkYmdAfter,hopeTdkTimeKbn){
            var _this = this;
            var rs;
            _this.sh063TdkReqModel.tdkSeq = _this.data.tdkSeq;
            _this.sh063TdkReqModel.tdkNo = _this.data.tdkNo;
            _this.sh063TdkReqModel.hopeTdkYmd = hopeTdkYmd;
            _this.sh063TdkReqModel.hopeTdkYmdAfter = hopeTdkYmdAfter;
            _this.sh063TdkReqModel.hopeTdkTimeKbn = hopeTdkTimeKbn;
            _this.sh063TdkReqModel.updateFlg = '1';
            
            if(_this.sh063Init.chakubiOption == 1 || _this.sh063Init.chakubiOption == 2){//0：なし 1：のみ 2：以降

                //お届け希望日指定
                if(common.stringNvl(_this.sh063TdkReqModel.tdkYmdHissuFlg) == '1'
                    && common.stringNvl(_this.sh063TdkReqModel.radioGroup1) == '2'){//のみ 必須
                        if (_this.sh063TdkReqModel.hopeTdkYmd == null || _this.sh063TdkReqModel.hopeTdkYmd == '' || _this.sh063TdkReqModel.hopeTdkYmd == undefined) {
                            alert("「お届け指定」欄の希望日を指定してください。");
                            return false;
                        }
                }

                //または、以降にお届け
                if(common.stringNvl(_this.sh063TdkReqModel.tdkYmdHissuFlg) == '1'
                    && common.stringNvl(_this.sh063TdkReqModel.radioGroup1) == '3'){//以降 必須
                        if (_this.sh063TdkReqModel.hopeTdkYmdAfter == null || _this.sh063TdkReqModel.hopeTdkYmdAfter == '' || _this.sh063TdkReqModel.hopeTdkYmdAfter == undefined) {
                            alert("「以降にお届け」欄の希望日を指定してください。");
                            return false;
                        }
                }
                //希望時間
                if(common.stringNvl(_this.sh063TdkReqModel.tdkHstmHissuFlg) == '1' && _this.sh063Init.tdkTimeFlg == 1){//必須
                    if (_this.sh063TdkReqModel.hopeTdkTimeKbn == null || _this.sh063TdkReqModel.hopeTdkTimeKbn == '' || _this.sh063TdkReqModel.hopeTdkTimeKbn == undefined) {
                        alert("希望時間を入力してください。");
                        return false;
                    }
                }
            } else {//0：なし 1：のみ 2：以降
                //お届け希望日必須
                if(common.stringNvl(_this.sh063TdkReqModel.tdkYmdHissuFlg) == '1'){//必須
                    if (_this.sh063TdkReqModel.hopeTdkYmd == null || _this.sh063TdkReqModel.hopeTdkYmd == '' || _this.sh063TdkReqModel.hopeTdkYmd == undefined) {
                        alert("お届け希望日を指定してください。");
                        return false;
                    }
                }
                //希望時間
                if(common.stringNvl(_this.sh063TdkReqModel.tdkHstmHissuFlg) == '1' && _this.sh063Init.tdkTimeFlg == 1){//必須
                    if (_this.sh063TdkReqModel.hopeTdkTimeKbn == null || _this.sh063TdkReqModel.hopeTdkTimeKbn == '' || _this.sh063TdkReqModel.hopeTdkTimeKbn == undefined) {
                        alert("希望時間を指定してください。");
                        return false;
                    }
                }
            }

            if(common.stringNvl(_this.sh063TdkReqModel.radioGroup1) == '1'){//指定なし
                _this.sh063TdkReqModel.hopeTdkYmd = '';
                _this.sh063TdkReqModel.hopeTdkYmdAfter = '';
            } else if(common.stringNvl(_this.sh063TdkReqModel.radioGroup1) == '2'){//のみ
                _this.sh063TdkReqModel.hopeTdkYmd = hopeTdkYmd;
                _this.sh063TdkReqModel.hopeTdkYmdAfter = '';
            } else if(common.stringNvl(_this.sh063TdkReqModel.radioGroup1) == '3'){//以降
                _this.sh063TdkReqModel.hopeTdkYmd = '';
                _this.sh063TdkReqModel.hopeTdkYmdAfter = hopeTdkYmdAfter;
            }
            console.log('_this.sh063TdkReqModel.hopeTdkYmd'+_this.sh063TdkReqModel.hopeTdkYmd);
            console.log('_this.sh063TdkReqModel.hopeTdkYmdAfter'+_this.sh063TdkReqModel.hopeTdkYmdAfter);

            rs = confirm(_this.$i18n.t('sh063.labels.confirmMess1'));
            if(rs){
                await axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH063 + _this.$UrlConstants.DO_UPDATE, _this.sh063TdkReqModel).then(function(response) {
                    if(response != null && response != undefined){
                        _this.sh063Init = response.data;
                    }
                })
                .catch(function(error) {
                    common.errorAPI(error);
                });
            }else{
                return false;
            }
            //画面を閉じる
            _this.showFlg = false;
        },

        // 配送希望日選択時
		hopeDayRadio:function(data){
            var _this = this;
            if(data == 1){
                //指定なし
                _this.sh063TdkReqModel.hopeTdkYmd = '';
                _this.sh063TdkReqModel.hopeTdkYmdAfter = '';
            }
            _this.$forceUpdate();
        },
        handleCancel(evt){
            evt.preventDefault();
            this.$emit("data-selected", null);
            this.showFlg = false;
        } 
    },

    /*
    * Excute code after an instance is created
    */
    created: function() {
        var _this = this;
        this.queryData = this.$route.query;
        if(this.queryData != null){
            if(this.queryData.ptPageNo != null){
                this.reqModel.pageNo = this.queryData.ptPageNo;
            }
            if(this.queryData.ptPageSize != null){
                this.reqModel.pageSize = this.queryData.ptPageSize;
            }
        }
        //Get param from router when contructor this.  
        var data = _this.$route.params;
        if (data.requestBack!=null){
            _this.reqModel = Object.assign({}, _this.reqModel, data.requestBack);
            _this.iSearch=true;
        }
    }
}
</script>